import React, { Component, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import "./Navbar.css"
import NoticiasAlertButton from '../noticias/NoticiasAlertButton';
import ParametrosApi from '../../services/robinhood/ParametrosApi';

export default function Navbar() {

  const [municipio, setMunicipio] = useState({ 'id': null, 'municipio': null });
  const [parametros, setParametros] = useState([]);
  const [pesquisa, setPesquisa] = useState(null);
  const parametrosApi = new ParametrosApi();

  const handlerToggleMenu = () => {
    if (document.getElementById('toggle-menu').className == 'theme-blush')
      document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
    else
      document.getElementById('toggle-menu').className = 'theme-blush';
  }

  const location = useLocation();
  let municipio_id = localStorage.getItem('municipio_id');

  useEffect(() => {
    new ParametrosApi().all().then(response => {
      setParametros(response);
    });
  }, []);

  useEffect(() => {
    municipio_id = localStorage.getItem('municipio_id');
    if (municipio_id)
      setMunicipio(JSON.parse(localStorage.getItem('municipio')));
  }, [location]);

  return (
    <>
      {/* <!-- Top Bar --> */}
      <nav className="navbar" style={{ zIndex: 1000 }}>
        <div className="col-12">

          <div className="navbar-header">
            <a href="javascript:void(0);" className="bars"></a>
            <Link className="navbar-brand" to='/'>
              <span className='text-center'
                style={{ color: 'white', marginLeft: '30px' }}>
                LEI ROBIN HOOD </span></Link>
          </div>

          <ul className="nav navbar-nav navbar-left">
            <li className="">
              <a href='javascript:void(0);'
                onClick={() => handlerToggleMenu()}
                className="ls-toggle-btn"
                data-close="true">
                <i className="zmdi zmdi-swap"></i>
              </a>
            </li>
            <li><Link to="/transferenciasglobais" className="" style={{ color: location.pathname == '/transferenciasglobais' ? '#dd5e89' : '' }} ><i className="zmdi zmdi-dot-circle-alt">
              <span className="spanSmall"> TRANSFERÊNCIAS ICMS / IPI </span></i> </Link>
            </li>
            <li><Link to="/" className="" style={{ color: location.pathname == '/extratos' || location.pathname == '/' ? '#dd5e89' : '' }}><i className="zmdi zmdi-dot-circle-alt">
              <span className="spanSmall"> DADOS DO MUNICÍPIO </span></i> </Link>
            </li>
            <NoticiasAlertButton></NoticiasAlertButton>

          </ul>
          <ul className="nav navbar-nav navbar-right">

            <li>
              <div className="row no-gutters aboutalign-items-center mr-3">
                <div className="">
                  <input className="form-control border-gray rounded-pill small pesquisar" type="text" placeholder='Pesquisar' onChange={(self) => setPesquisa(self.currentTarget.value)} id='input-pesquisar' />
                </div>
                <div className="col-auto">
                  <Link to={'/pesquisas'} className="btn border-0 shadow-none text-dark ml-n5" state={{ 'pesquisa': pesquisa }} style={{}}>
                    <i className="zmdi zmdi-search"></i>
                  </Link>
                </div>
              </div>
            </li>

            <li className="dropdown"><a href="javascript:void(0);" className="dropdown-toggle xs-hide" style={{ textDecoration: 'none' }} data-toggle="dropdown" role="button"><i className="zmdi zmdi-info-outline text-black"></i> <span className='spanSmall'>INFORMAÇÕES</span>
              <div className="notify"><span className="heartbit"></span><span className="point"></span></div>
            </a>
              <ul className="dropdown-menu slideDown">
                <li className="header text-muted"></li>
                <li className="body">
                  <ul className="menu list-unstyled">
                    <li>
                      <Link to={'/faqs'}>
                        <div className="icon-circle l-blue"> <i className="zmdi zmdi-help"></i> </div>
                        <div className="menu-info">
                          <h4>FAQ's</h4>
                          <p> Dúvidas Frequentes </p>
                        </div>
                      </Link>
                    </li>
                    <li><Link to={'/contatos'}>
                      <div className="icon-circle l-green"> <i className="zmdi zmdi-phone-in-talk"></i></div>
                      <div className="menu-info">
                        <h4>Fale Conosco</h4>
                        <p> Formas de contato </p>
                      </div>
                    </Link>
                    </li>
                    <li><Link to={"/parceiros"} >
                      <div className="icon-circle l-blue"> <i className="zmdi zmdi-accounts"></i></div>
                      <div className="menu-info">
                        <h4>Parceiros</h4>
                        <p> Entidades envolvidas </p>
                      </div>
                    </Link>
                    </li>
                    {parametros.filter(parametro => parametro.id == parametrosApi.informacoes_menu_historicos)[0] && parametros.filter(parametro => parametro.id == 1)[0].valor == '1' && <li> <Link to='/historicos'>
                      <div className="icon-circle l-green"> <i className="zmdi zmdi-time-restore"></i></div>
                      <div className="menu-info">
                        <h4>Históricos</h4>
                        <p> Sobre a Lei </p>
                      </div>
                    </Link>
                    </li>}
                    < li >
                      <Link to={'/documentos'}>
                        <div className="icon-circle l-amber"> <i className="zmdi zmdi-file-text"></i> </div>
                        <div className="menu-info">
                          <h4>Documentos</h4>
                          <p> Documentos Públicos </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <hr />
                      <Link to={'/staff'}>
                        <div className="icon-circle l-pink"> <i className="zmdi zmdi-help"></i> </div>
                        <div className="menu-info">
                          <h4>Sobre</h4>
                          <p> Sobre o portal </p>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="footer"><a href="javascript:void(0);"></a></li>
              </ul>
            </li>
          </ul>
        </div >
      </nav >
    </>
  )
}

